"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./slicedToArray-a539bf82.js"),
  t = require("react"),
  i = require("prop-types"),
  n = require("styled-components"),
  o = require("classnames"),
  l = require("./style-inject.es-dcee06b6.js");
function s(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var a = s(t),
  Q = s(i),
  r = s(o);
l.styleInject('.nmx-button.nmx-pcg{background:#bda263;background:linear-gradient(90deg,#e1c88f,#f2dfac 50%,#e1c88f);border:none;color:#4a4a4a;letter-spacing:3px;text-transform:uppercase}.nmx-button.nmx-pcg:hover{background:#bda263;background:linear-gradient(90deg,#d6be88,#e6d4a3 50%,#d6be88);border:none}.nmx-button.nmx-pcg:active,.nmx-button.nmx-pcg:focus{border:none}.nmx-link.nmx-pcg{color:#00487c}.nm-inline-tooltip{display:inline-flex}.nm-inline-tooltip__tooltip{display:inline-flex;margin-left:.5rem;position:relative}.nm-inline-tooltip__tooltip-icon-button{-webkit-appearance:none;background-color:#83d4f1;border:none;border-radius:100%;cursor:pointer;font-size:.8rem;height:1.2rem;line-height:1.3125rem;padding:0 0 0 1px;position:relative;top:.1rem;width:1.2rem}@media (min-width:48.0625em){.nm-inline-tooltip__tooltip-icon-button{top:0;top:-.1rem}}.nm-inline-tooltip__tooltip-icon-button:before{border-bottom:.5rem solid #83d4f1;border-left:.5rem solid transparent;border-right:.5rem solid transparent;content:"";height:0;left:50%;opacity:0;position:absolute;top:1.4rem;transform:translateX(-50%) translateY(0);transition:opacity .2s linear;visibility:hidden;width:0;z-index:3}.nm-inline-tooltip__tooltip-icon-button.nmx-pcg{background-color:#f2dfac;border-bottom:.5rem solid #f2dfac}.nm-inline-tooltip__tooltip-icon-button.nmx-pcg:before{border-bottom:.5rem solid #f2dfac}.nm-inline-tooltip__tooltip-icon-button.is-active:before{opacity:1;visibility:visible}.nm-inline-tooltip__dialog-window{background-color:#83d4f1;border-radius:.2rem;color:#000;font-size:1rem;font-weight:400;left:50%;line-height:1.2rem;margin-left:0;margin-top:1.9rem;opacity:0;padding:1.2rem;position:fixed;text-transform:none;transform:translateX(-50%) translateY(0);transition:visibility .2s,opacity .2s linear;visibility:hidden;width:95%;z-index:2}@media (min-width:64em){.nm-inline-tooltip__dialog-window{margin-left:.8rem;width:16rem}}@media (min-width:90em){.nm-inline-tooltip__dialog-window{margin-top:1.8rem;width:20rem}}.nm-inline-tooltip__dialog-window.nmx-pcg{background:#bda263;background:linear-gradient(90deg,#e1c88f,#f2dfac 50%,#e1c88f)}.nm-inline-tooltip__dialog-window.is-active,.nm-inline-tooltip__dialog-window.is-active:before{opacity:1;visibility:visible}.nm-inline-tooltip__dialog-window-close-btn{color:#0e497b;height:.5rem;padding:0;position:absolute;right:.6rem;top:.3rem;width:.5rem}@media (min-width:64em){.nm-inline-tooltip__dialog-window-close-btn{display:none}}.nm-inline-tooltip__dialog-window-close-btn.nmx-pcg{color:#000}.nm-inline-tooltip__tooltip-icon{height:100%;margin:0;pointer-events:none;top:0;width:100%}@media print{.nm-inline-tooltip{display:none}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZpbGU6Ly8vYnVpbGRzL25teC9saWJyYXJpZXMvbm14LXRlbXBsYXRlL3NyYy9hc3NldHMvc2Nzcy90aGVtZS9wY2cuc2NzcyIsImlubGluZS10b29sdGlwLnNjc3MiLCJmaWxlOi8vL2J1aWxkcy9ubXgvbGlicmFyaWVzL25teC10ZW1wbGF0ZS9zcmMvY29tcG9uZW50TGlicmFyeS9jb21wb25lbnRzL0lubGluZVRvb2x0aXAvaW5saW5lLXRvb2x0aXAuc2NzcyIsImZpbGU6Ly8vYnVpbGRzL25teC9saWJyYXJpZXMvbm14LXRlbXBsYXRlL3NyYy9hc3NldHMvc2Nzcy9zZXR0aW5ncy9jb2xvcnMuc2NzcyIsImZpbGU6Ly8vYnVpbGRzL25teC9saWJyYXJpZXMvbm14LXRlbXBsYXRlL3NyYy9hc3NldHMvc2Nzcy9zZXR0aW5ncy9icmVha3BvaW50cy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdERSxvQkFwQkEsa0JBQUEsQ0FDQSw2REFBQSxDQW9CRSxXQUFBLENBQ0EsYUExQ29CLENBMkNwQixrQkFBQSxDQUNBLHdCQ3JESixDRHlESSwwQkFsQkYsa0JBQUEsQ0FDQSw2REFBQSxDQWtCSSxXQ3JETixDRDZESSxxREFDRSxXQ3hETixDRDhERSxrQkFDRSxhQzNESixDQ2xCQSxtQkFDRSxtQkRxQkYsQ0NwQkUsNEJBR0UsbUJBQUEsQ0FGQSxpQkFBQSxDQUNBLGlCRHVCSixDQ3BCRSx3Q0FTRSx1QkFBQSxDQVJBLHdCQ21CZ0MsQ0RiaEMsV0FBQSxDQUNBLGtCQUFBLENBTkEsY0FBQSxDQVFBLGVBQUEsQ0FKQSxhQUFBLENBTUEscUJBQUEsQ0FSQSxpQkFBQSxDQURBLGlCQUFBLENBUUEsU0FBQSxDQU5BLFlENkJKLENHbURJLDZCRnJGRix3Q0FjSSxLQUFBLENBR0EsVURxQkosQ0FDRixDQ25CSSwrQ0FXRSxpQ0FBQSxDQUZBLG1DQUFBLENBQ0Esb0NBQUEsQ0FUQSxVQUFBLENBS0EsUUFBQSxDQU9BLFFBQUEsQ0FYQSxTQUFBLENBRUEsaUJBQUEsQ0FRQSxVQUFBLENBSkEsd0NBQUEsQ0FEQSw2QkFBQSxDQUpBLGlCQUFBLENBRUEsT0FBQSxDQVNBLFNEMEJOLENDeEJJLGdEQUNFLHdCRnhDTyxDRXlDUCxpQ0QwQk4sQ0N6Qk0sdURBQ0UsaUNEMkJSLENDdkJNLHlEQUNFLFNBQUEsQ0FDQSxrQkR5QlIsQ0NwQkUsa0NBS0Usd0JDcENnQyxDRHlDaEMsbUJBQUEsQ0FOQSxVRmpEa0IsQ0U2RGxCLGNBQUEsQ0FFQSxlQUFBLENBSkEsUUFBQSxDQUdBLGtCQUFBLENBSkEsYUFBQSxDQURBLGlCQUFBLENBSkEsU0FBQSxDQUdBLGNBQUEsQ0FSQSxjQUFBLENBRkEsbUJBQUEsQ0FNQSx3Q0FBQSxDQURBLDRDQUFBLENBSkEsaUJBQUEsQ0FPQSxTQUFBLENBTUEsU0R5QkosQ0dOSSx3QkZsQ0Ysa0NBcUJJLGlCQUFBLENBQ0EsV0R1QkosQ0FDRixDR1pJLHdCRmxDRixrQ0EyQkksaUJBQUEsQ0FEQSxXRHlCSixDQUNGLENDdkJJLDBDQUNFLGtCQUFBLENBQ0EsNkREeUJOLENDZk0sK0ZBQ0UsU0FBQSxDQUNBLGtCRHFCUixDQ2pCRSw0Q0FNRSxhQzNGb0IsQ0R1RnBCLFlBQUEsQ0FLQSxTQUFBLENBRkEsaUJBQUEsQ0FEQSxXQUFBLENBREEsU0FBQSxDQUZBLFdEeUJKLENHdkNJLHdCRmFGLDRDQVNJLFlEcUJKLENBQ0YsQ0NwQkksb0RBQ0UsVURzQk4sQ0NuQkUsaUNBRUUsV0FBQSxDQUVBLFFBQUEsQ0FEQSxtQkFBQSxDQUVBLEtBQUEsQ0FKQSxVRHlCSixDQ25CRSxhQS9IRixtQkFnSUksWURzQkYsQ0FDRiIsImZpbGUiOiJpbmxpbmUtdG9vbHRpcC5zY3NzIn0= */');
var d = function d(e, t, i, n) {
    "undefined" != typeof window && (window.addEventListener("resize", t), window.addEventListener("scroll", t), window.addEventListener("keydown", t)), function (e, t, i, n) {
      var o = document.getElementById(t);
      o.style.top = "".concat(n, "px"), e.matches ? o.style.left = "50%" : (o.style.left = "".concat(i, "px"), o.style["max-width"] = "".concat(2 * i, "px"));
    }(i, n, e.getBoundingClientRect().left, e.getBoundingClientRect().top);
  },
  c = function c(e, t) {
    function i() {
      t || "undefined" != typeof window && (window.removeEventListener("resize", i), window.removeEventListener("scroll", i), window.removeEventListener("keydown", i));
    }
    e && "Escape" === e.key && i(), i();
  },
  p = function p(e, t, i, n) {
    c(e, t), n(!1), i(!0), setTimeout(function () {
      i(!1);
    }, 300);
  },
  m = function m(e, t, i, n, o, l) {
    d(t, i, n, o), l(!0);
  },
  B = function B(i) {
    var n = i.branding,
      o = i.buttonId,
      l = i.modalId,
      s = i.tooltipText,
      Q = t.useState(!1),
      d = e._slicedToArray(Q, 2),
      B = d[0],
      x = d[1],
      E = t.useState(!1),
      U = e._slicedToArray(E, 2),
      b = U[0],
      u = U[1],
      F = "undefined" != typeof window && window.matchMedia("(max-width: 1023px)"),
      L = t.useRef(null);
    return a["default"].createElement("span", {
      className: "nm-inline-tooltip"
    }, a["default"].createElement("span", {
      className: "nm-inline-tooltip__tooltip"
    }, a["default"].createElement("button", {
      className: r["default"]("nm-inline-tooltip__tooltip-icon-button", {
        "is-active": B
      }, {
        "nmx-pcg": "pcg" === n
      }),
      "data-testid": o,
      id: o,
      onBlur: function onBlur(e) {
        return p(e, b, u, x);
      },
      onClick: function onClick(e) {
        return m(0, L.current, c, F, l, x);
      },
      onFocus: function onFocus(e) {
        return m(0, L.current, c, F, l, x);
      },
      onMouseEnter: function onMouseEnter(e) {
        return m(0, L.current, c, F, l, x);
      },
      onMouseLeave: function onMouseLeave(e) {
        return p(e, b, u, x);
      },
      ref: L,
      type: "button"
    }, "?")), a["default"].createElement("span", {
      className: r["default"]("nm-inline-tooltip__dialog-window", {
        "is-active": B
      }, {
        "nmx-pcg": "pcg" === n
      }),
      id: l
    }, a["default"].createElement("span", {
      className: r["default"]("nm-inline-tooltip__dialog-window-close-btn", {
        "is-active": B
      }, {
        "nmx-pcg": "pcg" === n
      })
    }, "✕"), s));
  };
B.propTypes = {
  branding: Q["default"].oneOf(["nm", "pcg"]),
  buttonId: Q["default"].string.isRequired,
  modalId: Q["default"].string.isRequired,
  themeType: Q["default"].oneOf(["lightTheme", "darkTheme"]),
  tooltipText: Q["default"].any.isRequired
}, B.defaultProps = {
  branding: "nm",
  themeType: "lightTheme"
};
var x = n.withTheme(B);
exports.InlineTooltip = x;